import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import {
  updateTopSection,
  updateRightSection,
  updateBottomSection,
  updateLeftSection,
  toggleFullScreen,
} from './sectionsSlice';
import { RootState } from '../../core/redux/store';
import sessionStorageSingleton from '../../core/configs/sessionStorageSingleton';
import { UserKeyStore, UserStorageDataType } from '../../core/database/schemas';
import { UserStorageParams } from '../../core/database/user/types';
import userStorageWorker from '../../core/database/user/userWorkerManager';

const sectionsSliceListener = createListenerMiddleware();

sectionsSliceListener.startListening({
  matcher: isAnyOf(
    updateTopSection,
    updateRightSection,
    updateBottomSection,
    updateLeftSection,
    toggleFullScreen
  ),
  effect: async (action, listenerApi) => {
    const state = listenerApi.getState() as RootState;

    const feKey = await sessionStorageSingleton.getFeKey(
      UserKeyStore.UserFeKey
    );

    if (state.auth.user.id && feKey && state.auth.app.isMasterTab) {
      const params: UserStorageParams = {
        actionType: action.type,
        userId: state.auth.user.id,
        feKey,
        data: {
          dataType: UserStorageDataType.Sections,
          sections: state.sections,
        },
      };
      userStorageWorker.postMessage(params);
    }
  },
});

export default sectionsSliceListener.middleware;
